<template>
  <div id="about">
      <PageLoader />
      <NavBar />
      <HeaderBar />

  <!-- ============ TITLE START ============ -->
		<section id="title">
			<div class="container">
				<div class="row">
					<div class="col-sm-12 text-center">
            <h1>Sobre a Workix</h1>
            <h4>Uma rede profissional enxuta, feita para conectar quem contrata a quem procura</h4>
					</div>
				</div>
			</div>
		</section>
  <!-- ============ TITLE END ============ -->

  <!-- ============ STORY START ============ -->
	<section id="story">
			<div class="container">
				<div class="row">
					<div class="col-sm-6">
						<h2>Afinal, o que é a Workix?</h2>

						<p>A Workix é uma plataforma de recrutamento que combina site de
							vagas, rede de perfis profissionais, páginas de empresas,
							ferramentas de busca e comunicação direta entre candidatos e
							recrutadores. O objetivo é simples: reduzir o peso, a demora e
							a burocracia dos processos seletivos tradicionais, tornando a
							experiência mais direta, transparente e acessível.</p>

						<p>Participar da Workix — criar perfil, publicar vaga,
							candidatar-se, buscar e ser encontrado — é e sempre será
							gratuito. O projeto se sustenta com assinaturas de ferramentas
							de recrutamento para empresas e com visibilidade adicional
							opcional, dos dois lados, sempre identificada como tal.</p>

						<h2>Inspirada no LinkedIn, com regras mais claras</h2>

						<p>O conceito nasce de um modelo semelhante ao de redes
							profissionais consagradas: perfis completos, páginas de
							empresa, publicação de vagas, busca por candidatos e conexão
							direta entre as duas pontas. A diferença está nas regras que
							colocamos em torno desse modelo — os Pactos da Workix:</p>

						<ul>
							<li><strong>Participar é sempre gratuito.</strong> Perfil,
								candidatura, publicação de vaga e busca no resultado
								orgânico não custam nada, em nenhum plano.</li>
							<li><strong>Toda visibilidade paga é identificada, sempre.</strong>
								Conteúdo pago nunca é disfarçado de resultado orgânico — e o
								código que garante isso é aberto.</li>
							<li><strong>Ninguém desaparece por não pagar.</strong> O
								resultado orgânico existe sempre, ordenado por relevância.</li>
							<li><strong>Seu contato só é liberado com o seu
								consentimento.</strong> Nenhuma empresa recebe e-mail,
								telefone ou currículo completo sem o seu aval.</li>
							<li><strong>Sem vaga fantasma.</strong> Toda vaga tem prazo e
								precisa de um desfecho.</li>
						</ul>

						<h2>Quem está por trás da Workix?</h2>

						<p>A Workix não pertence a uma empresa de recrutamento e não
							cobra comissão sobre contratações. É um projeto independente,
							criado para demonstrar que encontrar uma oportunidade
							profissional — ou o profissional certo — não precisa ser um
							processo caro, complexo ou obscuro. Os próprios participantes
							alimentam o sistema com currículos e vagas e utilizam a
							plataforma para conduzir suas interações até uma possível
							contratação.</p>
					</div>

					<div class="col-sm-6">

						<h2>O que torna a Workix diferente?</h2>

						<p>A Workix vende ferramentas de recrutamento para empresas
							(busca avançada, gestão de candidaturas, créditos de contato),
							a <strong>Vaga em Destaque</strong> — uma posição adicional de
							visibilidade, comprada pela empresa e sempre identificada com o
							rótulo "Patrocinada" — e o <strong>Workix Premium</strong>, para
							candidatos que queiram mais visibilidade na busca do
							recrutador e insights sobre suas candidaturas.</p>

						<p>O que a Workix não faz, em nenhum plano: não exibe conteúdo
							pago sem identificá-lo, não remove nem rebaixa quem não paga
							do resultado orgânico, não libera contato ou dado pessoal sem
							consentimento, não cobra do candidato para se candidatar ou
							para ser encontrado no orgânico, não vende dados de candidatos
							a terceiros e não cobra comissão sobre contratação.</p>

						<h2>Garantias</h2>

						<p>
							A Workix não garante o resultado de nenhum processo seletivo.
							Comprar destaque não muda isso: destaque compra alcance, nunca
							resultado.<br />
							Fornecemos as ferramentas de busca, o cadastro de currículos e
							vagas, a comunicação entre as partes e o feedback sobre
							interações relevantes. A condução do processo seletivo, assim
							como as decisões tomadas durante ele, é sempre de
							responsabilidade das partes envolvidas.
						</p>

						<h3>Quem criou o Projeto Workix?</h3>

						<p>
							<a href="http://www.codecode.com.br">Felipe Rodrigues Michetti</a>
							— Fundador &amp; Desenvolvedor Full Stack, atuando na
							construção da Workix desde o backend até o frontend e o
							aplicativo mobile. A iniciativa tem como objetivo tornar a
							busca por oportunidades profissionais mais justa, simples e
							acessível no Brasil.
						</p>
					</div>
				</div>
			</div>
		</section>
  <!-- ============ STORY END ============ -->

  <!-- ============ CAPABILITIES START ============ -->
	<section id="capabilities" class="color1">
			<div class="container">
				<div class="row text-center">
					<div class="col-sm-12">
						<h2>O que a Workix entrega</h2>
						<h4>As capacidades da plataforma, para quem contrata e para quem busca uma vaga</h4>
					</div>
				</div>
				<div class="row" style="margin-top: 30px;">
					<div class="col-sm-3">
						<div class="panel panel-default text-center">
							<div class="panel-body">
								<i class="fa fa-id-card fa-2x"></i>
								<h5>Perfil Profissional Completo</h5>
								<p>Currículo estruturado com formação, experiências e habilidades. Você controla sua própria visibilidade, em três chaves independentes.</p>
							</div>
						</div>
					</div>
					<div class="col-sm-3">
						<div class="panel panel-default text-center">
							<div class="panel-body">
								<i class="fa fa-building fa-2x"></i>
								<h5>Página de Empresa</h5>
								<p>Perfil público com vagas, localização, redes sociais e taxa de resposta sempre pública, com Selo de Empresa Verificada quando aplicável.</p>
							</div>
						</div>
					</div>
					<div class="col-sm-3">
						<div class="panel panel-default text-center">
							<div class="panel-body">
								<i class="fa fa-search fa-2x"></i>
								<h5>Busca de Vagas e Candidatos</h5>
								<p>Listagens paginadas, com filtro por tipo de contrato, cidade e nível de experiência. O resultado orgânico está sempre presente.</p>
							</div>
						</div>
					</div>
					<div class="col-sm-3">
						<div class="panel panel-default text-center">
							<div class="panel-body">
								<i class="fa fa-bullhorn fa-2x"></i>
								<h5>Publicação de Vagas</h5>
								<p>Toda empresa publica uma vaga ativa gratuitamente, sem taxa de publicação. Planos pagos ampliam a capacidade de gestão, não a posição na busca.</p>
							</div>
						</div>
					</div>
				</div>
				<div class="row" style="margin-top: 30px;">
					<div class="col-sm-3">
						<div class="panel panel-default text-center">
							<div class="panel-body">
								<i class="fa fa-star fa-2x"></i>
								<h5>Vaga em Destaque</h5>
								<p>Posição adicional, opcional e sempre identificada com o rótulo "Patrocinada". Nunca remove nem rebaixa o resultado orgânico.</p>
							</div>
						</div>
					</div>
					<div class="col-sm-3">
						<div class="panel panel-default text-center">
							<div class="panel-body">
								<i class="fa fa-line-chart fa-2x"></i>
								<h5>Workix Premium</h5>
								<p>Destaque opcional do perfil na busca do recrutador, insights sobre a vaga e contato direto, dentro de um limite de créditos mensais.</p>
							</div>
						</div>
					</div>
					<div class="col-sm-3">
						<div class="panel panel-default text-center">
							<div class="panel-body">
								<i class="fa fa-bell fa-2x"></i>
								<h5>Notificações em Tempo Real</h5>
								<p>Alertas por push e e-mail quando seu currículo é visualizado, uma mensagem chega ou seu contato é liberado.</p>
							</div>
						</div>
					</div>
					<div class="col-sm-3">
						<div class="panel panel-default text-center">
							<div class="panel-body">
								<i class="fa fa-newspaper-o fa-2x"></i>
								<h5>Blog e Conteúdo</h5>
								<p>Artigos sobre carreira, empregabilidade e mercado de trabalho, organizados por categoria e período.</p>
							</div>
						</div>
					</div>
				</div>
				<div class="row" style="margin-top: 30px;">
					<div class="col-sm-3">
						<div class="panel panel-default text-center">
							<div class="panel-body">
								<i class="fa fa-lock fa-2x"></i>
								<h5>Login Seguro</h5>
								<p>Autenticação via Firebase, com e-mail e senha ou conta Google. As senhas não são armazenadas pela Workix.</p>
							</div>
						</div>
					</div>
					<div class="col-sm-3">
						<div class="panel panel-default text-center">
							<div class="panel-body">
								<i class="fa fa-mobile fa-2x"></i>
								<h5>Experiência Multiplataforma</h5>
								<p>Desktop, notebook, tablet, smartphone e aplicativo mobile, com informações integradas entre os ambientes.</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
  <!-- ============ CAPABILITIES END ============ -->

  <!-- ============ DIFFERENTIALS START ============ -->
	<section id="differentials">
			<div class="container">
				<div class="row">
					<div class="col-sm-6">
						<h2>Diferenciais da nossa ferramenta</h2>

						<b>Feedback de verdade</b>

						<p>Quem nunca participou de um processo seletivo e nem ao
							menos recebeu uma resposta sobre o resultado final?</p>

						<p>A Workix busca melhorar essa relação por meio de uma
							experiência mais transparente: interações relevantes geram
							notificações e feedbacks para os envolvidos, e a taxa de
							resposta de cada empresa é pública — com ou sem destaque
							comprado, com ou sem selo.</p>

						<b>Acessível em qualquer dispositivo</b>

						<p>Tablet, celular, notebook ou desktop — o ambiente não
							importa. A Workix mantém as mesmas informações e
							funcionalidades essenciais em site responsivo e aplicativo
							mobile.</p>

						<b>Escalabilidade e crescimento orgânico</b>

						<p>Novas funcionalidades são adicionadas gradualmente, com foco
							em melhorar a experiência, automatizar etapas, reduzir tarefas
							manuais e aumentar a confiabilidade das informações trocadas
							entre as partes.</p>
					</div>

					<div class="col-sm-6">
						<h2>&nbsp;</h2>

						<b>Sem vagas fantasmas</b>

						<p>A Workix possui rotinas de manutenção que identificam e
							encerram automaticamente processos já concluídos. Toda vaga
							tem validade e seu status é atualizado ao longo do processo —
							e isso vale igualmente para vagas em destaque: destaque compra
							alcance, nunca isenta a vaga da validade e do desfecho
							obrigatório.</p>

						<b>Transparência de visibilidade</b>

						<p>Todo conteúdo patrocinado é identificado no próprio
							resultado, nunca misturado ao orgânico sem aviso — e a lógica
							que garante essa identificação está no código aberto do
							núcleo da Workix, não depende apenas da nossa palavra.</p>

						<b>Privacidade dos dados</b>

						<p>Não armazenamos senhas. Você tem controle sobre seu
							currículo e sua própria visibilidade, pode ativá-lo,
							desativá-lo ou solicitar a remoção dos seus dados a qualquer
							momento. Contato e dados pessoais só são liberados a uma
							empresa com o seu consentimento, mesmo quando ela tem plano
							pago.</p>

						<p><em>O e-mail verificado identifica cada cadastro de pessoa
							física — o CPF só é coletado na contratação efetiva, pela
							empresa contratante. O CNPJ identifica e verifica as pessoas
							jurídicas, por ser um dado público.</em></p>
					</div>
				</div>
			</div>
		</section>
  <!-- ============ DIFFERENTIALS END ============ -->

  <!-- ============ PROGRESS START ============ -->
	<section id="progress-status" class="color1">
			<div class="container">
				<div class="row text-center">
					<div class="col-sm-12">
						<h2>Fase atual do projeto</h2>
						<h4>A Workix é um projeto vivo, em desenvolvimento e testes contínuos</h4>
					</div>
				</div>
				<div class="row" style="margin-top: 20px;">
					<div class="col-sm-6">
						<p>Tradução e revisão dos textos</p>
						<div class="progress">
							<div class="progress-bar progress-bar-danger progress-bar-striped active"
								role="progressbar" aria-valuenow="90" aria-valuemin="0"
								aria-valuemax="100" style="width: 90%">90%</div>
						</div>

						<p>Backend web</p>
						<div class="progress">
							<div class="progress-bar progress-bar-success progress-bar-striped active"
								role="progressbar" aria-valuenow="75" aria-valuemin="0"
								aria-valuemax="100" style="width: 75%">75%</div>
						</div>
					</div>
					<div class="col-sm-6">
						<p>Front-end web</p>
						<div class="progress">
							<div class="progress-bar progress-bar-warning progress-bar-striped active"
								role="progressbar" aria-valuenow="70" aria-valuemin="0"
								aria-valuemax="100" style="width: 70%">70%</div>
						</div>

						<p>Aplicativo mobile</p>
						<div class="progress">
							<div class="progress-bar progress-bar-info progress-bar-striped active"
								role="progressbar" aria-valuenow="20" aria-valuemin="0"
								aria-valuemax="100" style="width: 20%">20%</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-12 text-center">
						<p><em>As mesmas vagas cadastradas aqui estarão disponíveis em qualquer dispositivo.</em></p>
					</div>
				</div>
			</div>
		</section>
  <!-- ============ PROGRESS END ============ -->

    <TestimonialsWrapper />
    <TeamWrapper />
    <ContactsWrapper />
    <FooterWrapper />
    <LoginPopup />
    <RegisterPopup />
  
  </div>
</template>

<script>
import PageLoader from '@/components/PageLoader.vue'
import NavBar from '@/components/NavBar.vue'
import HeaderBar from '@/components/HeaderBar.vue'
import TestimonialsWrapper from '@/components/TestimonialsWrapper.vue'
import TeamWrapper from '@/components/TeamWrapper.vue'
import ContactsWrapper from '@/components/ContactsWrapper.vue'
import FooterWrapper from '@/components/FooterWrapper.vue'
import LoginPopup from '@/components/LoginPopup.vue'
import RegisterPopup from "@/components/RegisterPopup.vue"
export default {
  components: {
    PageLoader,
    NavBar,
    HeaderBar,
    TestimonialsWrapper,
    TeamWrapper,
    ContactsWrapper,
    FooterWrapper,
    LoginPopup,
    RegisterPopup
  },
  created(){
	let ckeditor = document.createElement('script');  
    ckeditor.setAttribute('src',"js/settings.js");
    document.head.appendChild(ckeditor);
  }
}
</script>

<style>

</style>
